import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import Hero from "../../components/Hero";

interface PrincipalBannerProps {
  bgHero?: string;
  bgColor?: string;
  classNames?: string;
  children: React.ReactNode;
}

const PrincipalBanner = ({
  bgHero,
  bgColor,
  classNames,
  children,
}: PrincipalBannerProps) => {
  return (
    <Hero
      className={twMerge(
        clsx(
          "relative z-0 flex flex-col justify-center content-center",
          "p-2 min-h-[200px] md:min-h-[490px] font-manjari",
          "text-center text-xl overflow-hidden",
          `bg-${bgColor ?? "transparent"}`,
          classNames ?? ""
        )
      )}
    >
      {bgHero && (
        <div
          className={twMerge(
            clsx(
              "top-0 right-0 left-0 -z-[1] absolute bg-w-100",
              "bg-cover bg-no-repeat bg-center w-full h-full object-cover",
              "min-w-full h-full"
            )
          )}
          style={{ backgroundImage: `url(${bgHero})` }}
        />
      )}
      <div className="relative z-1 flex md:flex-row flex-col justify-center items-center content-center w-full h-full">
        {children}
      </div>
    </Hero>
  );
};

export default PrincipalBanner;
